"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _BaseTheme = _interopRequireDefault(require("../../Themes/BaseTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const ExternalLink = () => /*#__PURE__*/_react.default.createElement("svg", {
  viewBox: "0 0 26 26"
}, /*#__PURE__*/_react.default.createElement("path", {
  fill: _BaseTheme.default.colors.gray,
  d: "M21.9375,16.25 L20.3125,16.25 C19.8637686,16.25 19.5,16.6137686 19.5,17.0625 L19.5,22.75 L3.25,22.75 L3.25,6.5 L10.5625,6.5 C11.0112314,6.5 11.375,6.13623136 11.375,5.6875 L11.375,4.0625 C11.375,3.61376864 11.0112314,3.25 10.5625,3.25 L2.4375,3.25 C1.09130592,3.25 0,4.34130592 0,5.6875 L0,23.5625 C0,24.9086941 1.09130592,26 2.4375,26 L20.3125,26 C21.6586941,26 22.75,24.9086941 22.75,23.5625 L22.75,17.0625 C22.75,16.6137686 22.3862314,16.25 21.9375,16.25 Z M24.78125,0 L18.28125,0 C17.1960547,0 16.6537109,1.31574219 17.4179688,2.08203125 L19.2323828,3.89644531 L6.85546875,16.2687891 C6.62599293,16.4974695 6.49700768,16.8081044 6.49700768,17.1320703 C6.49700768,17.4560362 6.62599293,17.7666712 6.85546875,17.9953516 L8.00667969,19.1445312 C8.23536009,19.3740071 8.54599507,19.5029923 8.86996094,19.5029923 C9.1939268,19.5029923 9.50456178,19.3740071 9.73324219,19.1445312 L22.1040625,6.77015625 L23.9179688,8.58203125 C24.6796875,9.34375 26,8.81054687 26,7.71875 L26,1.21875 C26,0.545652961 25.454347,0 24.78125,0 Z"
}));

var _default = ExternalLink;
exports.default = _default;